interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  center?: boolean;
  align?: "left" | "center";
}

function SectionHeading({ eyebrow, title, desc, center = false }: SectionHeadingProps) {
  return (
    <div className={`mb-8 max-w-2xl ${center ? "mx-auto text-center" : ""}`}>
      <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
        <i className="ri-quill-pen-line"></i>
        {eyebrow}
      </span>
      <h2 className="mt-4 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
        {title}
      </h2>
      {desc && (
        <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
          {desc}
        </p>
      )}
    </div>
  );
}

export default SectionHeading;